import { createRootRouteWithContext, type ParsedLocation } from '@tanstack/react-router';
import { RootLayout } from '@/components/RootLayout';
import type { RouterContext } from '@/router';
import { isRegion, type Region } from '@/constants/regions';

interface RootSearch {
  // `datacenter` is appended by unified-platform to nav links across every route (not just
  // the region picker), so it's validated once here rather than re-parsed per-component.
  datacenter?: Region;
  // Transient flag the unified-platform "Impersonate" nav action appends to open the
  // impersonation modal. Recognized/typed here; TopHeader's close handler removes it from the
  // URL in place (via the History API) when the modal is dismissed — no navigation involved.
  impersonate_modal?: true;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  validateSearch: (search: Record<string, unknown>): RootSearch => ({
    datacenter: isRegion(search.datacenter) ? search.datacenter : undefined,
    impersonate_modal: search.impersonate_modal === true || search.impersonate_modal === 'true' ? true : undefined,
  }),
  beforeLoad: ({ context }: { context: RouterContext; location: ParsedLocation }) => {
    const { isAuthenticated, isLoading } = context.auth;

    if (isLoading) {
      return;
    }

    if (!isAuthenticated) {
      return; // allow AuthProvider to perform loginWithRedirect
    }
  },
  component: RootLayout,
});
